import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import OrderAllList from '../OrderAllList';
import OrderAllListSummaryBox from '../OrderAllListSummaryBox';
import OrderAllListSearchBox from '../OrderAllListSearchBox';
import { orderActions } from '../../../../../store/modules/order';

const OrderAllListWrap = ({ pageName }) => {
  const dispatch = useDispatch();
  const { filterOption, sortOption, searchOption, pagination } = useSelector((state) => state.order.orderAllList);

  const getOrderAllList = (data) => dispatch(orderActions.getOrderAllList(data));
  const reset = () => dispatch(orderActions.resetOrderAllList());

  const getList = (data) => {
    getOrderAllList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  useEffect(() => {
    return () => reset();
  }, []);

  return (
    <div className="order-all-list-wrap">
      {/* 주문 집계 정보 */}
      <OrderAllListSummaryBox />

      {/*주문 전체 서치 박스*/}
      <OrderAllListSearchBox getList={getList} />

      {/* 주문 전체 리스트 */}
      <OrderAllList getList={getList} pageName={pageName} />
    </div>
  );
};

export default OrderAllListWrap;
